<div class="d-flex justify-content-center" [style.margin]="margin + 'px'">
  <div class="spinner-grow text-primary" role="status" [style.width]="size + 'px'" [style.height]="size + 'px'">
    <span class="sr-only">Loading...</span>
  </div>
</div>
